import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractPromptDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractPromptDialogProperties";
import { CommonFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
/**
 * PromptDialogProperties.ts
 */
export class PromptDialogProperties extends AbstractPromptDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.titleFieldProperties.position = new PIXI.Point(512, 290);
        this.titleFieldProperties.size = new PIXI.Point(800, 160);
        this.messageFieldProperties.position = new PIXI.Point(512, 410);
        this.messageFieldProperties.size = new PIXI.Point(800, 350);
        this.cancelButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE, new PIXI.Point(150, 775));
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0);
        this.cancelButtonProperties.textFieldProperties.size = new PIXI.Point(200, 145);
        this.cancelButtonProperties.textFieldOffset.set(0, -8);
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE, new PIXI.Point(550, 775));
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(200, 145);
        this.confirmButtonProperties.textFieldOffset.set(0, -8);
    }
}
